module.exports = __webpack_public_path__ + "media/22.87d9bfc2.mp3";